import React, { useState, useRef } from 'react';
import { Modal, message } from 'antd';
import LOAD_STATUS from '@/constants/load-status';
import apis from '@/pages/activity-manage/apis';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import batchedUpdates from '@/common/utils/batched-updates';

// 商家端上下线操作
function useMerchantOnlineOperate() {
  const [status, setStatus] = useState(LOAD_STATUS.INIT);
  const statusRef = useRef(status);

  function toMerchantOnlineOperate(planCode, online, sucCb = () => {}, failCb = () => {}) {
    if (statusRef.current === LOAD_STATUS.ING) return;

    setStatus(LOAD_STATUS.ING);
    statusRef.current = LOAD_STATUS.ING;

    const a = online === 0 ? apis.activityPlanOnline : apis.activityPlanOffline;
    const errMsg = online === 0 ? '商家端上线失败' : '商家端下线失败';
    const sucMsg = online === 0 ? '商家端上线成功' : '商家端下线成功';

    a({ planCode: planCode })
      .then((res) => {
        const { ret } = res;
        if (ret === '0') {
          batchedUpdates(() => {
            sucCb();
            setStatus(LOAD_STATUS.SUCCESS);
            statusRef.current = LOAD_STATUS.SUCCESS;
          });
          message.success(sucMsg);
        } else {
          message.error(res.msg);
        }
      })
      .catch((ex) => {
        message.error(errMsg);
      });
  }

  return [toMerchantOnlineOperate];
}

export default function MerchantOnlineOperate(props) {
  const { planCode, online, updateConditions } = props;
  // 商家端上线、下线确认框
  const [onlineOperate] = useMerchantOnlineOperate();

  function toMerchantOnlineOperate(planCode, online) {
    onlineOperate(
      planCode,
      online,
      function () {
        updateConditions();
        console.log('商家端上下线成功');
      },
      function () {
        console.log('商家端上下线失败');
      }
    );
  }

  function showMerchantOnlineOperateConfirm(planCode, online) {
    Modal.confirm({
      className: 'merchant-online-operate-confirm',
      title: '',
      icon: <ExclamationCircleOutlined />,
      content:
        online === 0
          ? '操作商家端上线后，该营销活动会展示在商家端面向商家开放，非真实活动数据请勿操作！'
          : '操作商家端下线后，改营销活动将不再展示在商家端，请谨慎操作，避免反复修改给商家端带来的困扰！',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        return toMerchantOnlineOperate(planCode, online);
      },
      onCancel() {},
    });
  }
  return (
    <div onClick={() => showMerchantOnlineOperateConfirm(planCode, online)}>{online ? '商家端下线' : '商家端上线'}</div>
  );
}
